// extracted by mini-css-extract-plugin
export default {"Form":"_1Fk9LM3PYp87xJ23i8BRwc","columns":"_1r-d1lkqCPqpupvKZTHzZC","bad":"l9qxSV1i9sfwiVGvwJg9Y"};